import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Clock, ShoppingBag, Utensils } from 'lucide-react';
export function Deliverables() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-brand-gold" data-id="element-33" />,
    title: 'eBook Principal',
    subtitle: 'Plan Antinflamatorio 15-Min: Edición Chile.',
    desc: 'La guía completa adaptada a nuestra realidad.'
  }, {
    icon: <Clock className="w-8 h-8 text-brand-gold" data-id="element-34" />,
    title: 'Protocolo Reset 72h',
    subtitle: 'Deshinchazón express.',
    desc: 'El paso a paso para deshincharte de forma express antes de un evento.'
  }, {
    icon: <ShoppingBag className="w-8 h-8 text-brand-gold" data-id="element-35" />,
    title: "Lista de Compras 'Zero Estrés'",
    subtitle: 'Directo al súper.',
    desc: 'Qué comprar exactamente en el súper para no perder tiempo ni plata.'
  }, {
    icon: <Utensils className="w-8 h-8 text-brand-gold" data-id="element-36" />,
    title: 'Recetario Express',
    subtitle: 'Sabor chileno, sin culpa.',
    desc: 'Desayunos, almuerzos y cenas chilenas que se preparan en menos de 15 min.'
  }];
  return <section className="py-12 md:py-14 bg-brand-cream" data-id="element-37">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-38">
        <div className="text-center mb-16" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-navy" data-id="element-40">
            Todo lo que recibes hoy
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto mt-6 rounded-full" data-id="element-41"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-42">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-brand-navy/5 flex flex-col sm:flex-row gap-6 items-start group" data-id="element-43">
              <div className="p-4 bg-brand-cream rounded-xl group-hover:scale-110 transition-transform duration-300" data-id="element-44">
                {item.icon}
              </div>
              <div data-id="element-45">
                <h3 className="text-xl font-bold text-brand-navy mb-1" data-id="element-46">
                  {item.title}
                </h3>
                <p className="text-brand-gold font-medium mb-3 text-sm" data-id="element-47">
                  {item.subtitle}
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-48">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}